<div mat-dialog-title >Confirm</div>

<mat-dialog-content>
  {{message? message : 'Confirm action?'}}
</mat-dialog-content>

<mat-dialog-actions>
  <button class="mat-raised-button" (click)="dialogRef.close(true)">Yes</button>
  <button class="mat-raised-button" (click)="dialogRef.close(false)">No</button>
</mat-dialog-actions>